import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/CementplateCalculator/cementplateCalculator.container"
    ).then((module) => ({ default: module.CementplateCalculator }))
);
